import { render, staticRenderFns } from "./BirthdayField.vue?vue&type=template&id=45928fc8&"
import script from "./BirthdayField.vue?vue&type=script&lang=ts&"
export * from "./BirthdayField.vue?vue&type=script&lang=ts&"
import style0 from "./BirthdayField.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports